import { useRef } from 'react';
import debounce from 'lodash/debounce';
import { authFetch } from '../../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../../CommonUtils/urlWithParams';
import { httpBodyOptions } from '../../../../../../CommonUtils/httpBodyOptions';
import { OptionType } from '../../../../../../CommonComponents/OPL/Select/BaseSelect/types';

export interface SchoolDTO {
  housingCost: number;
  id: number;
  inStateTotal: number;
  inStateTuition: number;
  isPrivate: boolean;
  name: string;
  otherExpenses: number;
  outOfStateTotal: number;
  outOfStateTuition: number;
  state: string;
  suppliesCost: number;
}

export interface SchoolOption extends OptionType<number> {
  data: SchoolDTO;
}

export interface SearchSchoolsParams {
  clientId: string;
  term: string;
}

export const searchSchools = async ({
  clientId,
  term,
}: SearchSchoolsParams): Promise<SchoolOption[]> => {
  try {
    const { data } = await authFetch(
      urlWithParams('/Consumer/AutoComplete/ListSchools', { clientId }),
      {
        method: 'POST',
        ...httpBodyOptions({ term: term || '' }),
      },
    );

    return (data as SchoolDTO[]).slice(0, 20).map(school => ({
      label: school.name,
      value: school.id,
      rightLabel: school.state,
      data: school,
    }));
  } catch (error) {
    console.error(error);

    return [];
  }
};

interface Params {
  clientId: string;
}

export const useSearchSchoolsSelect = ({ clientId }: Params) => {
  const loadSchools = useRef(
    debounce((term, callback) => {
      searchSchools({ clientId, term }).then(opts => callback(opts));
    }, 300),
  ).current;

  return {
    loadSchools,
  };
};
